module.exports = __webpack_public_path__ + "src/assets/img/obshyak.4ab4aa30.jpg";